import axios from 'axios';
import { Service, SolutionType } from '../types';

/**
 * Gets a list of services by solution type
 *
 * @returns {Promise} List of {@link Service}
 */
export const fetchServices = async (
  type?: SolutionType
): Promise<Service[]> => {
  const queryParam = type ? `?solutionType=${type}` : '';
  return (await axios.get<Service[]>(`api/services${queryParam}`)).data;
};

/**
 * Gets a service by ID and solution type
 *
 * @returns {Promise} List of {@link Service}
 */
export const fetchService = async (
  serviceId: string,
  type?: SolutionType
): Promise<Service> => {
  const queryParam = type ? `?solutionType=${type}` : '';
  return (await axios.get<Service>(`api/service/${serviceId}${queryParam}`))
    .data;
};
